import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import VueCompositionAPI from '@vue/composition-api'
import axiosIns, { setRequestHeader } from '@/libs/axios'
import { isUserLoggedIn, setRefCode } from './auth/utils'
import { initTheme, initThemeAsync } from './theme/themeService'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'

// Initialize theme before Vue mount (sets CSS variables and body background).
// Synchronous fallback paints instantly; the admin-managed theme is then
// fetched from the API and applied in place (reactive, fire-and-forget).
const currentTheme = initTheme()
Vue.prototype.$theme = currentTheme
initThemeAsync(axiosIns)

// Create global event bus for cross-component communication
const EventBus = new Vue()
Vue.prototype.$eventBus = EventBus

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueClipboard)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

require('@core/assets/fonts/feather/iconfont.css')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// Capture the affiliate ref BEFORE handleAuth below — its router.replace('/')
// drops the query string. Re-writing on every landing keeps the URL value
// winning over a stored one and refreshes the attribution window.
const refParam = new URLSearchParams(window.location.search).get('ref')
if (refParam) setRefCode(refParam)

const vueInstance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const handleAuth = async appInstance => {
  if (isUserLoggedIn()) {
    const token = localStorage.getItem('accessToken')
    setRequestHeader('Authorization', `Bearer ${token}`)
  } else if (window.location.pathname !== '/register') {
    // Only redirect if not already on home page to avoid NavigationDuplicated error
    if (appInstance.$route.path !== '/') {
      appInstance.$router.replace('/').catch(err => {
        // Suppress NavigationDuplicated warnings
        if (err.name !== 'NavigationDuplicated') {
          console.error('Navigation error in handleAuth:', err)
        }
      })
    }
  }
}

handleAuth(vueInstance)
